require('./core/axios/axios_base');
require('./vue_core');




import store from './store';
import { EventBus } from './core/eventbus/eventbus';
import IMC_CORE from './libs/sys/imc_common';
import {ConfirmIMC} from "./libs/sys/confirm_imc";


window.EventBus = EventBus;
window.IMC_CORE = new IMC_CORE();
window.confirm_imc = ConfirmIMC;

store.dispatch('user/LOAD_USER');
store.dispatch('mem_count/LOAD_MENU_COUNTS');

EventBus.$on("reload_mem_count" ,e => {
	store.dispatch('mem_count/LOAD_MENU_COUNTS');
});

require ('./components/shared/core/base_components');


if(document.getElementById('user_profile')) {
	require('./components/user/profile/user_profile.js');
}


if(document.getElementById('os_gw')) {
	store.dispatch('uprox_status/LOAD_MENU_COUNTS');
}

if (jQuery('.mem_count_menu').length > 0) {
	require('./components/com_imc/dashboard/mem_count_menu.js');
}


require('./components/shared/base/init_components');
require('./components/shared/core/notification.js');
require('./components/com_sb/base/init_components');
require('./components/com_enginer/base/init_components');
require('./components/com_imc/base/init_components');
require('./components/com_report/base/init_components');





if (jQuery('#imc_vue_component').length > 0) {
	const current_component = jQuery('#imc_vue_component').attr('data-component');
	console.log('%c component loaded :' + current_component, window.IMC_CORE.css_info);

	if (current_component != '') {
		require('./components/com_imc/'+ current_component+'/index.js');
	}
}
